import React from "react";
import { getSectionData } from "../../utils/extractConfigData";

import styles from "./Tickets.module.css";

const dayMonthFormatter = new Intl.DateTimeFormat('nl-BE', { day: 'numeric', month: 'short', timeZone: 'Europe/Brussels' });
const timeFormatter = new Intl.DateTimeFormat('nl-BE', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Brussels' });

// Bouwt "7 aug 23:59" op uit losse dag/maand- en uur/minuut-formatters, zodat we niet
// afhankelijk zijn van locale-specifieke scheidingstekens (bv. een komma) in een
// gecombineerde datum+tijd-string
const formatAvailabilityDate = (date) => `${dayMonthFormatter.format(date)} ${timeFormatter.format(date)}`;

// Geeft een geldige Date terug voor ticket.toDate, of null als toDate leeg of ongeldig is
const getValidToDate = (ticket) => {
  if (!ticket.toDate) return null;
  const date = new Date(ticket.toDate);
  return Number.isNaN(date.getTime()) ? null : date;
};

// Een ticket is nog beschikbaar zolang de huidige tijd de toDate (indien ingesteld en geldig) niet is gepasseerd
const isTicketAvailable = (ticket) => {
  const toDate = getValidToDate(ticket);
  if (!toDate) return true;
  return new Date() <= toDate;
};

const Tickets = () => {
  const sectionData = getSectionData("tickets");

  if (!sectionData.enabled) return "";

  const visibleTickets = sectionData.tickets.filter(t => t.show !== false);
  const visibleTicketNotes = visibleTickets.filter(ticket => ticket.note);
  const priceFormatter = new Intl.NumberFormat('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <section id={sectionData.id} className={styles.section}>
      <div className={styles.container}>
        <div className={styles.content}>
          <p className={styles.title}>{sectionData.title}</p>
          {sectionData.text.map((paragraph, index) => (
            <p key={index} className={styles.text}>
              {paragraph}
            </p>
          ))}
          {sectionData.showTicketTypes && visibleTickets.length > 0 ? (
            <div className={styles.text}>
              <ul className={styles.ticketList}>
                {visibleTickets.map(ticket => {
                  const available = isTicketAvailable(ticket);
                  const displayPrice = !available
                    ? "Niet meer beschikbaar"
                    : ticket.price === 0 ? (ticket.note ? "Gratis*" : "Gratis") : `€${priceFormatter.format(ticket.price)}`;
                  const validToDate = getValidToDate(ticket);
                  const availabilityText = available && validToDate ? `(tot ${formatAvailabilityDate(validToDate)})` : null;

                  return (
                    <li key={ticket.name}>
                      <span className={`${styles.ticketName} ${!available ? styles.ticketNameUnavailable : ""}`}>{ticket.name}</span>{" "}
                      {displayPrice}
                      {ticket.text && <span className={styles.ticketText}> {ticket.text}</span>}
                      {availabilityText && <span className={styles.availability}> {availabilityText}</span>}
                    </li>
                  );
                })}
              </ul>
              {visibleTicketNotes.map(ticket => (
                <p key={ticket.name} className={styles.note}>
                  {ticket.note}
                </p>
              ))}
            </div>
          ) : null}
          <p className={styles.link}>
            <a className={styles.button} href={sectionData.link} target="_blank" rel="noreferrer">
              Tickets Kopen
            </a>
          </p>
        </div>
      </div>
    </section>
  );
};

export default Tickets;
